/* eslint-disable no-undef */
import { SET_VALIDATED } from 'constants/actionTypes';
import { getActiveResource } from 'helpers/modalHelpers';
import { validateFields } from 'validation/fieldValidation';

/*
  Check form validity for all fields by native Form validation + custom check
  which constructs a validation result message.

  SPEC-23
*/
export const validateResource = () => (dispatch, getState) => {
  const state = getState();
  const resource = getActiveResource(state);

  const invalidFields = validateFields(Object.values(resource.fields));
  const isValidHTML = resource.ref.current.checkValidity();

  dispatch({ type: SET_VALIDATED });

  if (!isValidHTML || invalidFields.length > 0) {
    return {isValid: false, msg: '\n' + invalidFields.join('\n')};
  }

  return {isValid: true};
};